import { StudyStatus } from "features/optimization/state/studyAtoms";
import { alertAuthExpired, fetchFfdJson } from "shared/api/ffdClient";

export const fetchStudyStatus = async (
  authToken: string,
  name: string
): Promise<StudyStatus | null> => {
  try {
    const { response, data } = await fetchFfdJson<{ body: any; text?: string }>(
      `/studies/status?study_name=${encodeURIComponent(name)}`,
      authToken
    );
    if (response.ok) {
      return {
        name: name,
        running: data.body?.RUNNING ?? 0,
        complete: data.body?.COMPLETE ?? 0,
        pruned: data.body?.PRUNED ?? 0,
        failed: data.body?.FAIL ?? 0,
      } as StudyStatus;
    } else {
      if (data.text) alert(data.text);
      return null;
    }
  } catch (error) {
    alertAuthExpired();
    return null;
  }
};
